import { render, staticRenderFns } from "./addressCreate.vue?vue&type=template&id=0f4a3915&scoped=true&"
import script from "./addressCreate.vue?vue&type=script&lang=js&"
export * from "./addressCreate.vue?vue&type=script&lang=js&"
import style0 from "./addressCreate.vue?vue&type=style&index=0&id=0f4a3915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a3915",
  null
  
)

export default component.exports